import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalAddOccurrenceType(props) {

    const [br, setBR] = useState(false);

    const [tittle, setTittle] = useState();
    const { storageId, user } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleAddSynthetic(e) {
        e.preventDefault();
        const response = await api.post(`/occurrence/type/${storageId}`, {
            id_user: user.id,
            tittle
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.loadOccurrenceType();
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar Titulo de Ocorrencia
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddSynthetic}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Titulo</Form.Label>
                            <Form.Control onChange={event => setTittle(event.target.value)} type="text" placeholder="Nome do Titulo" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar Titulo
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Sintético adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddOccurrenceType;